import ConfigParameter, { gettext } from "../ConfigParameter";

export default class Children extends ConfigParameter {

    constructor() {
        super('children',
            'columns',
            gettext('Columns count'),
            'mainConfig',
            [[],[]],
            null,
            [1, 2, 3, 4],
            null,
            null,
            gettext("Normally section is split into 12 columns. Adjust their widths according to your personal preferences. Remember that sum of widths bigger than max(12) will cause collumns to collapse."));
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Children.js